import { useSelector } from 'react-redux';
import { SwiperClass } from 'swiper/react';

import { IRootState } from 'Scripts/store';
import { IVariantImageViewModel } from 'Scripts/Types/Litium';

import { useLazyGetProductQuery } from 'Services/productDetailApi';
import { getMoveDirection } from 'Utils/getMoveDirection';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

const ProductImageThumbnails = ({ swiper }: { swiper: SwiperClass }) => {
    const variantId = useSelector(
        (state: IRootState) => state?.productDetailPage.productItem.id
    );

    const thumbnails = useSelector(
        (state: IRootState) =>
            state?.productDetailPage.productItem.variantThumbnails
    );
    const [getProduct, { isFetching: isFetchingProduct }] =
        useLazyGetProductQuery();
    const handleChangeVariant = (id: string, slideIndex: number) => {
        getProduct({
            id,
            slideIndex,
        });
    };

    const goToSlide = (index: number) => {
        if (swiper.realIndex === index) return;
        const moveDirection = getMoveDirection(
            swiper.realIndex,
            index,
            swiper.slides.length
        );
        if (moveDirection === 'next') {
            swiper.slideNext();
        } else if (moveDirection === 'previous') {
            swiper.slidePrev();
        } else {
            swiper.slideToLoop(index);
        }
    };

    const handleThumbClick = (
        thumbnail: IVariantImageViewModel,
        thumbnailList: IVariantImageViewModel[]
    ) => {
        if (isFetchingProduct) return false;

        const slideIndex = thumbnailList
            .filter(x => x.id === thumbnail.id)
            .findIndex(u => u === thumbnail);
        if (thumbnail.id === variantId) {
            goToSlide(slideIndex);
        } else {
            handleChangeVariant(thumbnail.id, slideIndex);
        }
    };
    return (
        <ul className="grid grid-cols-8 gap-3">
            {thumbnails.map((thumbnail, index: number) => (
                <li key={`${index}-${thumbnail.id}`}>
                    <button
                        disabled={isFetchingProduct}
                        onClick={() => handleThumbClick(thumbnail, thumbnails)}
                        className={`w-full border border-solid p-[1px] ${
                            thumbnail.id !== variantId
                                ? 'border-transparent'
                                : 'border-silverChalice'
                        }`}
                    >
                        <picture>
                            <source
                                width={105}
                                height={147}
                                media={`(min-width: ${tailwindBreakpoints.xxl})`}
                                srcSet={`${thumbnail.src}?format=webp&height=147&width=105&fit=crop`}
                            />
                            <source
                                width={98}
                                height={137}
                                media={`(min-width: ${tailwindBreakpoints.xl})`}
                                srcSet={`${thumbnail.src}?format=webp&height=118&width=84&fit=crop`}
                            />
                            <img
                                className="w-full"
                                src={`${thumbnail.src}?format=webp&height=95&width=68&fit=crop`}
                                alt={thumbnail.altText}
                                width={68}
                                height={95}
                                loading="lazy"
                            />
                        </picture>
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default ProductImageThumbnails;
